module.exports = function getResource(label, vars = []) {
    let resources = {
        waiverTitle: 'Waiver of Rights and Assumption of Risk',
        waiverGeneralMessage: `Please review ${vars[0]}, and check the following boxes that apply.`,
        acceptWaiver: `By checking the box, I acknowledge I am the individual who is receiving Sephora’s services.  I acknowledge I have carefully read and fully understand all provisions of the ${vars[0]}, and freely and knowingly assume the risks and waive my rights as described.`,
        underAgeWaiver: 'I am booking for someone under the age of 18.',
        parentalWaiver: `By checking the box, I acknowledge I am the parent or legal guardian of a minor who is receiving Sephora’s services.  I acknowledge I have carefully read and fully understand all provisions of the ${vars[0]}, and freely and knowingly assume the risks and waive any right to bring suit on behalf of the minor as described.`
    };

    return resources[label];
};
